import styled from 'styled-components';

export const Wrapper = styled.div`
	position: relative;
	width: 100%;
	white-space: nowrap;
	overflow-x: scroll;
	-webkit-overflow-scrolling: touch;
	background: transparent;
	border-radius: 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	z-index: 99;
	@media (max-width: 600px) {
	    font-size: .8rem;
		height: 35px;
		span {
			margin-bottom: 0px !important;
		}
	}
    .arrow-left {
        margin: 6px 6px 0px 11px !important;
		@media (max-width: 600px) {
        	margin: 2px 2px 0px 7px !important;
		}
    }
	.arrow-right {
        margin: 6px 11px 0px 11px !important;
		@media (max-width: 600px) {
        	margin: 2px 7px 0px 7px !important;
		}
    }
	.arrow {
		width: 11px;
		height: 11px;
		color: #919191;
	}
	.row-flex {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}
	.text {
		color: #919191;
		font-weight: 400;
		font-size: 14px;
		display: inline-block;
		@media (max-width: 600px) {
			font-size: 11px;
		}
	}
	.active {
		color: #121212;
		font-weight: 600;
		font-size: 14px;
		display: inline-block;
		@media (max-width: 600px) {
			font-size: 11px;
		}
	}
`;